/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { bool, shape, arrayOf, func, number } from "prop-types";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";

import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import * as config from "util/config";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";

import { selectors as metrocorpSelectors, actions as metrocorpActions } from "reducers/metrocorp";
import { MetrocorpMovementCard } from "@ui-kit/components/index.es";
import { get as i18nGet } from "util/i18n";
import Pagination from "pages/_components/pagination/Pagination";
import Spinner from "pages/_components/Spinner";

const FORM_ID = "metrocorp.list";

class MetrocorpMovementsListGroup extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        movements: arrayOf(shape({})).isRequired,
        dispatch: func.isRequired,
        handleOpenBottomSheetClick: func.isRequired,
        optionSelected: shape({}).isRequired,
        filtersData: shape({}).isRequired,
        clients: arrayOf(shape({})).isRequired,
        totalPages: number.isRequired,
        fullMovementsList: arrayOf(shape({})),
        localPage: number,
    };

    static defaultProps = {
        fullMovementsList: [],
        localPage: 1,
    };

    getCurrencyFromDescriptions = (descripcionEspecie, descripcionEspecieRelacionada) => {
        let currency = "";
        if (descripcionEspecieRelacionada === "PESOS" || descripcionEspecie === "PESOS") {
            currency = "0";
        } else if (descripcionEspecieRelacionada.startsWith("DOLAR") || descripcionEspecie.startsWith("DOLAR")) {
            currency = "2";
        }
        return currency;
    };

    handleDetail = (
        referenciaMinuta,
        codEspe,
        nombre,
        apellido,
        descripcionEspecie,
        descripcionEspecieRelacionada,
        observaciones,
    ) => {
        const { dispatch, handleOpenBottomSheetClick } = this.props;
        handleOpenBottomSheetClick();
        const currency = this.getCurrencyFromDescriptions(descripcionEspecie, descripcionEspecieRelacionada);
        dispatch(
            metrocorpActions.getMovementDetail(
                referenciaMinuta,
                codEspe.trim(),
                nombre,
                apellido,
                currency,
                observaciones,
            ),
        );
    };

    handleExportItemMobile = (
        referenciaMinuta,
        codEspe,
        nombre,
        apellido,
        descripcionEspecie,
        descripcionEspecieRelacionada,
        index,
        observaciones,
    ) => {
        const { dispatch } = this.props;
        const currency = this.getCurrencyFromDescriptions(descripcionEspecie, descripcionEspecieRelacionada);

        dispatch(
            metrocorpActions.downloadMetrocorpDetailByReference(
                index,
                referenciaMinuta,
                codEspe.trim(),
                nombre,
                apellido,
                currency,
                "pdf",
                observaciones,
            ),
        );
    };

    getCardLabel = (key) => {
        const labels = {
            movementDate: `${FORM_ID}.movements.column.movementDate`,
            specie: `${FORM_ID}.movements.column.species`,
            nominalValue: `${FORM_ID}.movements.column.nominal`,
        };
        return i18nGet(labels[key]);
    };

    getFilteredAndPaginatedMovements = () => {
        const { fullMovementsList, filtersData, localPage, isDesktop } = this.props;
        const enableFrontendPagination = config.getBoolean("metrocorp.tenencia.tipo.functionalities", false);

        if (
            !enableFrontendPagination ||
            !fullMovementsList ||
            !Array.isArray(fullMovementsList) ||
            fullMovementsList.length === 0
        ) {
            return null;
        }

        if (!filtersData) {
            return null;
        }

        const rowsPerPage = config.getInteger("metrocorp.rowsPerPage", 10);
        const species = filtersData.species || "all";
        const currentLocalPage = localPage || 1;

        const filteredMovements =
            species === "all"
                ? fullMovementsList
                : fullMovementsList.filter((m) => {
                      const movementSpecies = m.codEspe?.trim() || "";
                      const filterSpecies = species.trim();
                      return movementSpecies === filterSpecies;
                  });

        if (filteredMovements.length === 0) {
            return { paginatedMovements: [], totalPages: 0, currentPage: currentLocalPage };
        }

        const totalPages = Math.ceil(filteredMovements.length / rowsPerPage);
        const validPage = Math.max(1, Math.min(currentLocalPage, totalPages));
        const startIndex = (validPage - 1) * rowsPerPage;

        if (isDesktop) {
            const paginatedMovements = filteredMovements.slice(startIndex, startIndex + rowsPerPage);
            return { paginatedMovements, totalPages, currentPage: validPage };
        }

        const paginatedMovements = filteredMovements.slice(0, startIndex + rowsPerPage);

        return { paginatedMovements, totalPages, currentPage: validPage };
    };

    nextPage = (page) => {
        const { dispatch, optionSelected, filtersData, clients, isDesktop } = this.props;
        const enableFrontendPagination = config.getBoolean("metrocorp.tenencia.tipo.functionalities", false);

        if (enableFrontendPagination) {
            dispatch(metrocorpActions.setLocalPage(page));
            return;
        }

        const { principalAccount, species, date, dateFrom, dateTo } = filtersData;
        const selectedClient = clients.filter((client) => client.codClie === principalAccount)[0];
        dispatch(
            metrocorpActions.listMetrocorp(
                optionSelected,
                `${selectedClient.nombre} ${selectedClient.apellido}`,
                principalAccount,
                species,
                date,
                dateFrom,
                dateTo,
                page,
                isDesktop,
            ),
        );
    };

    renderListForMovements = () => {
        const { movements, filtersData, totalPages, isDesktop } = this.props;
        const enableFrontendPagination = config.getBoolean("metrocorp.tenencia.tipo.functionalities", false);

        let movementsToRender = movements || [];
        let pagesToRender = totalPages || 1;
        let currentPage = filtersData?.page || 1;

        if (enableFrontendPagination) {
            const localData = this.getFilteredAndPaginatedMovements();
            if (localData) {
                const { paginatedMovements, totalPages: localTotalPages, currentPage: localCurrentPage } = localData;
                movementsToRender = paginatedMovements;
                pagesToRender = localTotalPages;
                currentPage = localCurrentPage;
            }
        }

        if (!(movementsToRender && movementsToRender.length > 0)) {
            return (
                <div className="text-center no-more-data">
                    <div className="illustration-wrapper">
                        <Image src="images/loupeInFile.svg" className="svg-big-icon" />
                    </div>
                    <p className="text-lead">
                        <I18n id={`${FORM_ID}.empty.message`} />
                    </p>
                </div>
            );
        }

        const endOfListItem = (
            <div className="table-row" key="noMoreTransactions">
                <div className="table-data text-center">
                    <I18n id="transactions.list.noMoreTransactions" />
                </div>
            </div>
        );

        return isDesktop ? (
            <>
                {movementsToRender.map((item, index) => this.renderListForMovementsItem(item, index))}
                <div className="d-flex justify-content-end w-100 my-3 pr-2">
                    <Pagination
                        totalPages={pagesToRender || 1}
                        pageNumber={currentPage}
                        action={this.nextPage}
                        showFirstAndLastButton
                        showText
                    />
                </div>
            </>
        ) : (
            <InfiniteScroll
                dataLength={movementsToRender.length}
                next={() => this.nextPage(enableFrontendPagination ? currentPage + 1 : (filtersData?.page || 1) + 1)}
                hasMore={
                    enableFrontendPagination
                        ? currentPage < pagesToRender
                        : (filtersData?.page || 1) < (totalPages || 1)
                }
                loader={<Spinner />}
                endMessage={endOfListItem}
                scrollableTarget={isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined}>
                {movementsToRender.map((item, index) => this.renderListForMovementsItem(item, index))}
            </InfiniteScroll>
        );
    };

    renderListForMovementsItem = (item, index) => {
        const { isDesktop } = this.props;
        const {
            descripcionEspecie,
            referenciaMinuta,
            codEspe,
            Nombre,
            Apellido,
            descripcionEspecieRelacionada,
            observaciones,
            movementsGrouped,
        } = item;

        const hideDescription = config.getBoolean("frontend.show.metrocorp.AdjustmentsMov.functionalities", false);

        const mapMovement = (m) => ({
            id: m.referenciaMinuta,
            date: m.fechaMovimiento,
            description: m.descripcionOperacion,
            amount: m.importe,
            type: m.importe < 0 ? "debit" : "credit",
            specie: `${m.codEspe.trim()}${hideDescription ? "" : ` - ${m.descripcionEspecie}`}`,
            showTicket: isDesktop ? !!(m.referenciaMinuta && m.numeroBoleto) : !!m.numeroBoleto,
        });

        const movement = {
            ...mapMovement(item),
            movementsGrouped: movementsGrouped ? movementsGrouped.map(mapMovement) : undefined,
        };

        const handleShowTicket = () => {
            if (isDesktop) {
                this.handleDetail(
                    referenciaMinuta,
                    codEspe,
                    Nombre,
                    Apellido,
                    descripcionEspecie,
                    descripcionEspecieRelacionada,
                    observaciones,
                );
            } else {
                this.handleExportItemMobile(
                    referenciaMinuta,
                    codEspe,
                    Nombre,
                    Apellido,
                    descripcionEspecie,
                    descripcionEspecieRelacionada,
                    index,
                    observaciones,
                );
            }
        };

        const itemKey = referenciaMinuta ? `${referenciaMinuta}-${index}` : index;

        return (
            <MetrocorpMovementCard
                key={itemKey}
                movement={movement}
                getCardLabel={this.getCardLabel}
                handleShowTicket={handleShowTicket}
            />
        );
    };

    render() {
        const { isDesktop } = this.props;
        return <div className={!isDesktop ? "px-3" : ""}>{this.renderListForMovements()}</div>;
    }
}

const mapStateToProps = (state) => ({
    detail: metrocorpSelectors.getMovementDetail(state),
    fetchingDetailDownloadByReferenceMobile: metrocorpSelectors.getFetchingDetailDownloadByReferenceMobile(state),
    filtersData: metrocorpSelectors.getFiltersData(state),
    clients: metrocorpSelectors.getClients(state),
    totalPages: metrocorpSelectors.getMovementsTotalPages(state),
    fullMovementsList: metrocorpSelectors.getFullMovementsList(state) || [],
    localPage: metrocorpSelectors.getLocalPage(state),
});

export default connect(mapStateToProps)(MetrocorpMovementsListGroup);
